export function FadedDotsBackground() {
  return (
    <div className="bg-points pointer-events-none absolute inset-0 -z-10"></div>
  );
}
